import axios from "axios";

export const fetcher = async (...args: any) => {
  const [url, params] = args;
  const { data } = await axios.get(url, {
    params,
  });
  return data;
};
